import React from 'react'

function ActivePatient() {
  return (
    <div>ActivePatient</div>
  )
}

export default ActivePatient